import "./App.css";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTopUtils";
import { LoaderProvider } from "./context/LoaderContext";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import AnimatedRoutes from "./routes/AnimatedRoutes";
import { ToastContainer } from "react-toastify";
import { CartProvider } from "./context/CartContext";
import { HelmetProvider } from "react-helmet-async";
import PageLoader from "./context/PageLoader";
import { Suspense } from "react";

function App() {
  return (
    <>
      <HelmetProvider>
        <CartProvider>
          <SiteConfigProvider>
            <LoaderProvider>
              <BrowserRouter>
                <ScrollToTop />

                <Suspense fallback={<PageLoader />}>
                  <AnimatedRoutes />
                </Suspense>
                
              </BrowserRouter>
            </LoaderProvider>
          </SiteConfigProvider>
        </CartProvider>
      </HelmetProvider>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
